import { render } from "./Park.vue?vue&type=template&id=5ced1b3c"
import script from "./Park.vue?vue&type=script&lang=js"
export * from "./Park.vue?vue&type=script&lang=js"
script.render = render

export default script